<template>
  <a-pagination
    class="custom-pagination"
    v-model="current"
    show-size-changer
    :page-size-options="pageSizeOptions"
    :page-size.sync="pageSize"
    :default-current="1"
    :total="total"
    @change="onChange"
    @showSizeChange="onShowSizeChange"
  >
    <template slot="buildOptionText" slot-scope="props">
      <span>{{ props.value }} 条/页</span>
    </template>
  </a-pagination>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    total: {
      type: Number,
      default: 400
    },
    pageSizeOptions: {
      type: Array,
      default: function() {
        return ['10', '20', '30', '40', '50']
      }
    }
  },
  data () {
    return {
      current: 1,
      pageSize: Number(this.pageSizeOptions[0])
    }
  },
  methods: {
    onChange (pageNumber) {
      this.$emit('pageChange', {pageNumber})
    },
    onShowSizeChange (current, pageSize) {
      this.$emit('pageSizeChange', {current, pageSize})
    }
  }
}
</script>

<style lang="less">
  @import "../../assets/style/index";
  .custom-pagination.ant-pagination{
    line-height: 28px;
    .ant-pagination-prev, .ant-pagination-next, .ant-pagination-jump-prev, .ant-pagination-jump-next{
      min-width: 22px;
      height: 22px;
      line-height: 22px;
      color: #C0C4CC;
      &.ant-pagination-disabled{
        .ant-pagination-item-link{
          color: #606266;
        }
      }
      .ant-pagination-item-ellipsis{
        color: #606266;
        font-size: 12px;
      }
    }
    .ant-pagination-item{
      background-color: transparent;
      border: none;
      min-width: 22px;
      height: 22px;
      line-height: 22px;
      margin: 0 10px 0 10px;
      a{
        font-size: 14px;
        color: @pageBaseColor;
      }
      &-active{
        background-color: #CE2323;
        border-radius: 50%;
        a {
          color: #fff;
        }
      }
    }
    .ant-pagination-options{
      float: left;
      margin: 0;
    }
    .ant-select{
      float: left;
      margin-right: 30px;
      width: 100px;
    }
    .ant-select-selection--single{
      height: 28px;
      line-height: 28px;
      background-color: transparent;
      border: 1px solid #666666;
      border-radius: 3px;
      color: @pageBaseColor;
    }
    .ant-select-selection__rendered{
      line-height: 28px;
    }
    .ant-select-arrow{
      color: @pageBaseColor;
    }
    .ant-pagination-item-link{
      background-color: transparent;
      border: none;
      color: @pageBaseColor;
      line-height: 22px;
      .ant-pagination-item-link-icon{
        color: @pageBaseColor;
      }
      &:hover{
        color: @pageBaseColor;
        
      }
      .anticon{
        vertical-align: middle;
      }
    }
  }
</style>